import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import {
  getSearchParam,
  removeFromSearchParam,
  urlHasSearchParam,
} from '~/client/src/shared/utils/urlutils'

// Seeds state from a one-shot URL search param (validated against a known set),
// then clears the param on mount so a later refresh/remount no longer re-applies
// it. Returns a [value, setValue] pair like useState — the caller owns the value
// after the initial seed (e.g. deep-linking into a specific tab the user can
// then switch away from). Falls back when the param is absent or not allowed.
export function useConsumedSearchParamState<T extends string>(
  key: string,
  allowedValues: T[],
  fallback: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    const param = getSearchParam(key)
    return allowedValues.includes(param as T) ? (param as T) : fallback
  })

  useEffect(() => {
    if (urlHasSearchParam(key)) {
      removeFromSearchParam(key)
    }
  }, [key])

  return [value, setValue]
}
